import { useClientTranslation } from '@/lib/core/i18n';
import type { WhereFromSheetProps } from '../types';
import { LocationPicker } from './locationPicker';

export function WhereFromSheet({ isOpen, onClose, cmsProps, booking, onBookingChange }: WhereFromSheetProps) {
  const t = useClientTranslation();

  return (
    <LocationPicker
      isOpen={isOpen}
      onClose={onClose}
      title={cmsProps?.title ?? t('App.Labels.WhereFrom')}
      subtitle={cmsProps?.subtitle}
      pickupPoint={booking.pickupPoint}
      dropoffPoint={booking.dropoffPoint}
      target="pickup"
      onSelect={point => {
        onBookingChange({ pickupPoint: point });
        onClose();
      }}
    />
  );
}
